module.exports = __webpack_public_path__ + "assets/LineAlongPoints.23c1adca19b5440e7f810685f6149364.gmt";


//////////////////
// WEBPACK FOOTER
// ./src/resources/levels/Gmt/LineAlongPoints.gmt
// module id = 968
// module chunks = 0